import React, { useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { useAuth } from '../../context/AuthContext';
import { Button } from '../ui/button';

export const Header = () => {
    const location = useLocation();
    const { isAuthenticated, user, logout } = useAuth();
    const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);

    const isActiveRoute = (path) => {
        return location.pathname === path;
    };

    const toggleMobileMenu = () => {
        setIsMobileMenuOpen(!isMobileMenuOpen);
    };

    return (
        <header className="bg-white shadow">
            <nav className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
                <div className="flex justify-between h-16">
                    <div className="flex items-center space-x-8">
                        <Link
                            to="/"
                            className="text-xl font-bold text-primary-600 hover:text-primary-700 transition-colors"
                        >
                            Paper Insight
                        </Link>

                        <div className="h-6 w-px bg-gray-200 hidden sm:block" aria-hidden="true" />

                        <div className="hidden sm:flex sm:items-center sm:space-x-8">
                            <Link
                                to="/subscription"
                                className={`px-3 py-2 rounded-md text-sm font-medium transition-colors
                                    ${isActiveRoute('/subscription')
                                        ? 'text-primary-600 bg-primary-50'
                                        : 'text-gray-700 hover:text-primary-600 hover:bg-gray-50'
                                    }`}
                            >
                                내 구독설정
                            </Link>
                            <Link
                                to="/my-reports"
                                className={`px-3 py-2 rounded-md text-sm font-medium transition-colors
                                        ${isActiveRoute('/my-reports')
                                        ? 'text-primary-600 bg-primary-50'
                                        : 'text-gray-700 hover:text-primary-600 hover:bg-gray-50'
                                    }`}
                            >
                                내 리포트
                            </Link>
                            <Link
                                to="/papers"
                                className={`px-3 py-2 rounded-md text-sm font-medium transition-colors
                                    ${isActiveRoute('/papers')
                                        ? 'text-primary-600 bg-primary-50'
                                        : 'text-gray-700 hover:text-primary-600 hover:bg-gray-50'
                                    }`}
                            >
                                논문 검색
                            </Link>
                            <Link
                                to="/reports"
                                className={`px-3 py-2 rounded-md text-sm font-medium transition-colors
                                    ${isActiveRoute('/reports')
                                        ? 'text-primary-600 bg-primary-50'
                                        : 'text-gray-700 hover:text-primary-600 hover:bg-gray-50'
                                    }`}
                            >
                                일일 리포트
                            </Link>

                        </div>
                    </div>

                    {/* Auth Section */}
                    <div className="flex items-center">
                        {/* Hamburger button */}
                        <button
                            type="button"
                            className="sm:hidden inline-flex items-center justify-center p-2 rounded-md text-gray-500 hover:text-primary-600 hover:bg-gray-100 focus:outline-none focus:ring-2 focus:ring-inset focus:ring-primary-500"
                            aria-expanded="false"
                            onClick={toggleMobileMenu}
                        >
                            <span className="sr-only">Open main menu</span>
                            {/* Hamburger icon */}
                            <svg
                                className="h-6 w-6"
                                xmlns="http://www.w3.org/2000/svg"
                                fill="none"
                                viewBox="0 0 24 24"
                                stroke="currentColor"
                                aria-hidden="true"
                            >
                                <path
                                    strokeLinecap="round"
                                    strokeLinejoin="round"
                                    strokeWidth="2"
                                    d="M4 6h16M4 12h16M4 18h16"
                                />
                            </svg>
                        </button>

                        <div className="hidden sm:flex items-center ml-4">
                            {isAuthenticated ? (
                                <div className="flex items-center space-x-4">
                                    <span className="text-sm text-gray-700">
                                        Slack 로그인
                                    </span>
                                    <Button
                                        variant="ghost"
                                        onClick={logout}
                                    >
                                        Logout
                                    </Button>
                                </div>
                            ) : (
                                <Link to="/auth">
                                    <Button variant="outline">
                                        Login
                                    </Button>
                                </Link>
                            )}
                        </div>
                    </div>
                </div>

                {/* Mobile menu, show/hide based on menu state */}
                {isMobileMenuOpen && (
                    <div className="sm:hidden">
                        <div className="pt-2 pb-3 space-y-1">
                            <Link
                                to="/subscription"
                                className={`block px-3 py-2 rounded-md text-base font-medium transition-colors
                                    ${isActiveRoute('/subscription')
                                        ? 'text-primary-600 bg-primary-50'
                                        : 'text-gray-700 hover:text-primary-600 hover:bg-gray-50'
                                    }`}
                                onClick={() => setIsMobileMenuOpen(false)}
                            >
                                내 구독설정
                            </Link>
                            <Link
                                to="/my-reports"
                                className={`block px-3 py-2 rounded-md text-base font-medium transition-colors
                                        ${isActiveRoute('/my-reports')
                                        ? 'text-primary-600 bg-primary-50'
                                        : 'text-gray-700 hover:text-primary-600 hover:bg-gray-50'
                                    }`}
                                onClick={() => setIsMobileMenuOpen(false)}
                            >
                                내 리포트
                            </Link>
                            <Link
                                to="/papers"
                                className={`block px-3 py-2 rounded-md text-base font-medium transition-colors
                                    ${isActiveRoute('/papers')
                                        ? 'text-primary-600 bg-primary-50'
                                        : 'text-gray-700 hover:text-primary-600 hover:bg-gray-50'
                                    }`}
                                onClick={() => setIsMobileMenuOpen(false)}
                            >
                                논문 검색
                            </Link>
                            <Link
                                to="/reports"
                                className={`block px-3 py-2 rounded-md text-base font-medium transition-colors
                                    ${isActiveRoute('/reports')
                                        ? 'text-primary-600 bg-primary-50'
                                        : 'text-gray-700 hover:text-primary-600 hover:bg-gray-50'
                                    }`}
                                onClick={() => setIsMobileMenuOpen(false)}
                            >
                                일일 리포트
                            </Link>
                            <div className="mt-4 pt-4 border-t border-gray-200">
                                {isAuthenticated ? (
                                    <div className="flex flex-col space-y-2">
                                        <span className="px-3 py-2 text-sm text-gray-700">
                                            Slack 로그인
                                        </span>
                                        <Button
                                            variant="ghost"
                                            onClick={() => {
                                                logout();
                                                setIsMobileMenuOpen(false);
                                            }}
                                            className="justify-start"
                                        >
                                            Logout
                                        </Button>
                                    </div>
                                ) : (
                                    <Link
                                        to="/auth"
                                        onClick={() => setIsMobileMenuOpen(false)}
                                    >
                                        <Button variant="outline" className="w-full">
                                            Login
                                        </Button>
                                    </Link>
                                )}
                            </div>
                        </div>
                    </div>
                )}
            </nav>
        </header>
    );
};